var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDistributors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 33C1 15.3269 15.3269 1 33 1V1C50.6731 1 65 15.3269 65 33V33C65 50.6731 50.6731 65 33 65V65C15.3269 65 1 50.6731 1 33V33Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M24.1198 28.5L13 32.5V53.1573H24.1198V59H38V44.9783H24.2358L24.1198 28.5Z",
    fill: "#DDDBDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M59 36H42V59H59V36Z",
    fill: "#DDDBDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M16 41H8V64H16V41Z",
    fill: "#DDDBDB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 25.5H35L34 38L40 36.197L38.5 25.5Z",
    fill: "#3E4756"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 20H43L42 35L48 32.8364L46.5 20Z",
    fill: "#3E4756"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31 59H12V37.1094L31 31V59Z",
    fill: "#00A0F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50 60H28V37.3276L50 31V60Z",
    fill: "#00A0F3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7203 21.7797C37.6422 22.0453 37.4865 22.2717 37.2764 22.4248C37.0663 22.5779 36.8133 22.6494 36.5553 22.6287C36.2973 22.6079 36.0484 22.496 35.8458 22.3097C35.6433 22.1233 35.4981 21.8727 35.4321 21.5955C35.0069 19.8582 35.1536 17.9513 36.7718 16.3899C40.8984 12.4147 41.5355 14.9956 41.6742 16.4887C41.7766 17.5607 40.1484 20.4893 37.7203 21.7797Z",
    fill: "#CCD6DD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 12C40.6716 12 40 11.5523 40 11C40 10.4477 40.6716 10 41.5 10C42.3284 10 43 10.4477 43 11C43 11.5523 42.3284 12 41.5 12Z",
    fill: "#CCD6DD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22 54H18V59H22V54Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4321 59H8.56789C8.25425 59 8 60.3431 8 62C8 63.6569 8.25425 65 8.56789 65H52.4321C52.7457 65 53 63.6569 53 62C53 60.3431 52.7457 59 52.4321 59Z",
    fill: "#3E4756"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M38 40H34V45H38V40Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M38 47H34V52H38V47Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M37 40H33V45H37V40Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M37 47H33V52H37V47Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M29 40H25V45H29V40Z",
    fill: "#E9E8E8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M29 47H25V52H29V47Z",
    fill: "#E9E8E8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M46 40H42V45H46V40Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M46 47H42V52H46V47Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M33 64C15.8792 64 2 50.1208 2 33H0C0 51.2254 14.7746 66 33 66V64ZM64 33C64 50.1208 50.1208 64 33 64V66C51.2254 66 66 51.2254 66 33H64ZM33 2C50.1208 2 64 15.8792 64 33H66C66 14.7746 51.2254 0 33 0V2ZM33 0C14.7746 0 0 14.7746 0 33H2C2 15.8792 15.8792 2 33 2V0Z",
    fill: "#E6EBEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributors);
export default __webpack_public_path__ + "static/media/Distributors.ea78e346ac82ad8b39bb192860552e55.svg";
export { ForwardRef as ReactComponent };